<div>
  <div style="padding: 15px col-3">
    <form [formGroup]="formData">
      <label
        *ngIf="
          group.name === 'relative' ||
          group.name === 'personal details' ||
          group.name === 'people who are important to me'
        "
        >{{ question.label }}</label
      >
      <ng-select
        formControlName="field"
        [items]="items"
        [(ngModel)]="selected"
        bindLabel="value"
        bindValue="key"
        [ngClass]="{ 'is-invalid': form.field.errors }"></ng-select>
      <div
        class="mt-2"
        *ngIf="form.field.errors"
        style="font-size: 80%; color: rgb(244 106 106)">
        <span *ngIf="form.field.errors.required"
          >Please provide a valid response.</span
        >
      </div>
    </form>
  </div>
</div>
